import { AppBar, Box, Button, Stack, Toolbar, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import BottomNavBar from "./BottomNav";

const Header = () => {
  const [bottomNavState, setBottomNavState] = React.useState({
    value: 0,
    pathMap: ["/", "/simulation", "/about", "/faq", "/contact"],
  });

  const handleBottomNavStateChange = (event, value) => {
    setBottomNavState({ ...bottomNavState, value });
  };

  return (
    <React.Fragment>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#4d82cb",
          color: "white",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          "& a": {
            color: "#fff",
            textDecoration: "none",
          },
          "& a:hover": {
            color: "#DDD",
          },
        }}
      >
        <Toolbar>
          <Typography
            variant="h6"
            sx={{
              display: "inline-block",
              margin: 0,
              flexGrow: 1,
              "& a": {
                fontSize: "1.75rem",
                fontWeight: 500,
              },
            }}
          >
            <Link to="/" color="inherit">
              MTXPK.org
            </Link>
          </Typography>
          <Box
            sx={{
              [(theme) => theme.breakpoints.down("md")]: {
                display: "none",
              },
            }}
          >
            <Box
              sx={{
                display: { xs: "none", md: "block" },
                float: "right",
              }}
            >
              <Stack direction="row" spacing={5}>
                <Button
                  component={Link}
                  to="/simulation"
                  color="inherit"
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  Simulation Tool
                </Button>
                <Button
                  component={Link}
                  to="/about"
                  color="inherit"
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  About
                </Button>
                <Button
                  component={Link}
                  to="/faq"
                  color="inherit"
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  FAQ
                </Button>
                <Button
                  component={Link}
                  to="/contact"
                  color="inherit"
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  Contact
                </Button>
              </Stack>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <BottomNavBar
        bottomNavState={bottomNavState}
        handleBottomNavStateChange={handleBottomNavStateChange}
      />
    </React.Fragment>
  );
};

export default Header;
